import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import WarningListItem from './WarningListItem';
export default class WarningPreview extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.warning = this.attrs.warning;
  }
  view() {
    return m(Link, {
      className: "WarningPreview",
      href: app.route('user.warnings', {
        username: this.warning.warnedUser().username()
      })
    }, m(WarningListItem, {
      warning: this.warning
    }));
  }
}
flarum.reg.add('fof-moderator-warnings', 'forum/components/WarningPreview', WarningPreview);